export const AGRO_ON_HEELS = [68, 69, 70, 71];
export const PRESS = [53, 54, 55, 56];
export const GREEN_CHANGES = [
  57,
  60,
  61,
  62,
  63,
  64,
  65,
  66,
  67,
  91,
  94,
  95,
  96,
  97,
  98,
  99,
  100,
  101,
  102,
  103,
  104,
];
export const LAW = [79, 74, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89];
export const FINANCE = [75, 47, 48, 49, 51, 76, 77, 78];
export const FOOD_AGRO = [18, 28, 39, 34, 28, 23, 72];
export const MAKRO_ANALYSIS = [90];
